export default {
  'not_found.title': '이 페이지는 생성되지 않았습니다',
  'not_found.description': '이 페이지에 대해 더 알려주시면 생성해 드리겠습니다',
};
